import PropTypes from 'prop-types';

export const Props = {
  /** The id of the checkbox */
  id: PropTypes.string,
  /** The name of the checkbox */
  name: PropTypes.string,
  /** The value of the checkbox */
  value: PropTypes.string,
  /** If true, the checkbox is checked by default */
  checked: PropTypes.bool,
  /** If true, the checkbox is required */
  required: PropTypes.bool,
  /** If true, the checkbox is disabled */
  disabled: PropTypes.bool,
  /** The type of the input element, could be either checkbox or radiobutton */
  type: PropTypes.oneOf(['checkbox', 'radio']),
  /** Specify wether the label/contents should be displayed 'before' or 'after' the input element */
  position: PropTypes.oneOf(['before', 'after']),
  /** Validation rules that are applied when the input element state changes (checked or unchecked) */
  validation: PropTypes.func,
  /** The callback function which is triggered upon input element change event */
  callback: PropTypes.func,
  /**
   * HTML element or Component to render as the checkbox content.
   */
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.string,
    PropTypes.object,
  ]),
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
